export const validateVideoLink = (url) => {
    // Regex for YouTube URLs (handles both youtube.com and youtu.be)
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]+/;
    // Regex for Vimeo URLs
    const vimeoRegex = /^(https?:\/\/)?(www\.)?vimeo\.com\/\d+/;

    return (
      youtubeRegex.test(url) ||
      vimeoRegex.test(url)
    );
};

export const extractVideoLinks = (text) => {
  const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)[\w-]+/g;
  const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/\d+/g;

  const youtubeLinks = text.match(youtubeRegex) || [];
  const vimeoLinks = text.match(vimeoRegex) || [];

  return [...youtubeLinks, ...vimeoLinks];
};



export const validateImageLink = (url) => /\.(jpe?g|png|gif|bmp|webp)(\?.*)?$/i.test(url)